import React, { Component } from 'react';
import './styles.scss';

type Props = {
  options: MenuOption[];
  isChatEnded?: string;
};
type State = {
  isMenuOpen: boolean;
};

export default class Menu extends Component<Props, State> {
   node: HTMLDivElement | null | undefined;
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
  }

  setInitialState(): State {
    return {
      isMenuOpen: false,
    };
  }

  toggleMenu() {
    if (!this.state.isMenuOpen) {
      document.addEventListener("click", this.handleOutsideClick, false);
    } else {
      document.removeEventListener("click", this.handleOutsideClick, false);
    }

    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
    }));
  }

  handleOutsideClick = (e:any) => {
    if (this.node && !this.node.contains(e.target)) {
      this.toggleMenu();
    }
  };

  render() {
    return (
      <div
        className={`sf-menu clickable ${this.state.isMenuOpen ? 'open' : ''}`}
        onClick={() => {
          this.toggleMenu();
        }}>
        <div>
          <div className='dot'></div>
          <div className='dot'></div>
          <div className='dot'></div>
        </div>
        <div
          ref={node => {this.node = node;}}
          className='menu-options'
          style={
            this.props.isChatEnded
              ? { display: this.state.isMenuOpen ? 'grid' : 'none', top: '46px' }
              : { display: this.state.isMenuOpen ? 'grid' : 'none' }
          }>
          {this.props.options.map((option, index) => {
            return (
              <div
                key={index}
                className='option'
                onClick={() => {
                  option.onClick();
                }}>
                {option.name}
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export type MenuOption = {
  name: string;
  onClick: Function;
};
